export default __webpack_public_path__ + "static/icon_cc_heart-6e846a5598c8434a8ca5a7122c28484e.png";